import {
	TransformedPermission,
	UserPermissionRoleInfo,
} from '@dealstack/frontend/shared/components/UserPermissions/UserPermissions.types';
import {
	getLowestPermissionRole,
	PermissionRoleWithOwner,
	PermissionRoleWithOwnerEnum,
	PermissionWithOwner,
	ResourceType,
} from '@dealstack/shared/lib/common/fineGrainedAuthorization/permissions';

const checkIfResourceMustHaveAtLeastOnePermission = (resourceType: ResourceType): boolean => {
	return resourceType === ResourceType.DEAL || resourceType === ResourceType.PROGRAMME;
};

export const transformPermissions = ({
	resourcePermissions,
	userPermissions,
	disablePermissionForCurrentUser,
	resourceType,
}: {
	resourcePermissions: { label: string; value: PermissionRoleWithOwner; description?: string }[];
	userPermissions: PermissionWithOwner[];
	disablePermissionForCurrentUser: boolean;
	resourceType: ResourceType;
}): TransformedPermission[] => {
	const mustHaveAtLeastOnePermission = checkIfResourceMustHaveAtLeastOnePermission(resourceType);

	return resourcePermissions.map((item) => {
		const userPermissionState = getUserPermissionState(userPermissions, item.value);
		const lowestPermissionRole = getLowestPermissionRole(resourceType);

		const isLowestPermission = item.value === lowestPermissionRole;
		const isOwner = item.value === PermissionRoleWithOwnerEnum.OWNER;

		const shouldDisableLowestPermission = isLowestPermission && mustHaveAtLeastOnePermission;

		const disabled =
			shouldDisableLowestPermission ||
			isOwner ||
			userPermissionState?.isImplicit === true ||
			disablePermissionForCurrentUser;
		const checked = userPermissionState?.isEnabled ?? false;

		return {
			...item,
			checked,
			disabled,
			isImplicit: userPermissionState?.isImplicit,
		};
	});
};

const getUserPermissionState = (
	userPermissions: PermissionWithOwner[],
	role: PermissionRoleWithOwner
): UserPermissionRoleInfo | undefined => {
	const userPermission = userPermissions.find((perm) => perm.permissionRole === role);
	if (!userPermission) {
		return;
	}

	return { isEnabled: true, ...userPermission };
};
